import classNames from 'classnames';
import { useRef } from 'react';
import { useInView } from 'framer-motion';

type LineProps = string | JSX.Element;

interface Props {
  lines: [LineProps, LineProps];
  className?: string;
}

function DoubleLineText({ lines, className }: Props) {
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true });

  return (
    <div
      ref={ref}
      className={classNames(['flex flex-col', className])}
    >
      {lines.map((line, i) => (
        <div
          key={lines.indexOf(line)}
          className="relative -mt-[10px] overflow-hidden py-[10px]"
        >
          <span
            className={classNames([
              'block transition-all duration-1000 ease-out',
              i === 1
                ? '-translate-y-[200%] delay-700'
                : 'translate-y-[200%]',
              isInView && '!translate-y-0'
            ])}
          >
            {line}
          </span>
        </div>
      ))}
    </div>
  );
}

export default DoubleLineText;
